import { Form } from 'src/app/models/form.model';
import { UserService } from './../../services/user.service';
import { MatDialog, MatSidenav, MatIconRegistry, MatSnackBar } from '@angular/material';
import { Component, ViewChild, OnInit, TemplateRef } from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { BorradoresComponent } from '../borradores/borradores.component';
import { crearBorradorComponent } from '../borradores/crearBorrador/crearBorrador.component';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import * as FormActions from '../../reducers/actions/forms.actions';
import * as FinalFormactions from '../../reducers/actions/form_final.actions';
import { SidenavService } from 'src/app/services/sidenav.service';
import { SolicitudesExpComponent } from '../solicitudesexp/solicitudesexp.component';
import { DomSanitizer } from '@angular/platform-browser';
import { ToastrService } from 'ngx-toastr';
import { Notification } from 'src/app/models/notification.model';
import * as NotificationActions from '../../reducers/actions/notification.actions';
import { FinalForm } from 'src/app/models/final_form.model';
import { GLOBAL } from 'src/app/services/global';
import { NgxSpinnerService } from 'ngx-spinner';

interface AppState {
  form: Form;
}
interface AppStateNotification {
  contador: Notification
}

interface AppStateFinalForm {
  formFinal: FinalForm
}

declare const swal: any;

@Component({
  selector: 'main-nav',
  templateUrl: './main-nav.component.html',
  styleUrls: ['./main-nav.component.css'],
  providers: [SidenavService]

})

export class MainNavComponent implements OnInit {
  @ViewChild('drawer') sidenav: MatSidenav;
  @ViewChild('modalCargarBorrador') modalCargarBorrador: TemplateRef<any>;

  public materias = [];

  isExpanded = true;
  showSubmenu: boolean = false;
  isShowing = false;
  showSubSubMenu: boolean = false;
  form: Observable<Form>
  identity;
  token;
  title;
  allowNewOption = true;

  public activo;
  public notification_count;
  public contador_definitivo: Number
  public footer = GLOBAL.footer;
  public web = GLOBAL.web;
  public webUrl = GLOBAL.webUrl;
  public nombreMuni = GLOBAL.nombreMuni;
  public showModule = GLOBAL.showModule;
  public generico = GLOBAL.generico;
  public forms = GLOBAL.forms
  public expandedItem;
  public comunas = [];

  isHandset$: Observable<boolean> = this.breakpointObserver.observe(Breakpoints.Handset)
    .pipe(
      map(result => result.matches)
    );

  constructor(
    private breakpointObserver: BreakpointObserver,
    private dialog: MatDialog,
    private storeN: Store<AppStateNotification>,
    private _router: Router,
    private _userService: UserService,
    private store: Store<AppState>,
    private storeF: Store<AppStateFinalForm>,
    private _sidenavService: SidenavService,
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer,
    private toastr: ToastrService,
    private spinner: NgxSpinnerService,
    private snackBar: MatSnackBar
  ) {

    this.matIconRegistry.addSvgIcon("obramenor", this.domSanitizer.bypassSecurityTrustResourceUrl('./assets/permisos/obramenor.svg'))
      .addSvgIcon("edificacion", this.domSanitizer.bypassSecurityTrustResourceUrl('./assets/permisos/edificacion.svg'))
      .addSvgIcon("subdivision", this.domSanitizer.bypassSecurityTrustResourceUrl('./assets/permisos/houses.svg'))
      .addSvgIcon("division", this.domSanitizer.bypassSecurityTrustResourceUrl('./assets/permisos/parquet.svg'))
      .addSvgIcon("copropiedad", this.domSanitizer.bypassSecurityTrustResourceUrl('./assets/permisos/profiles.svg'))
      .addSvgIcon("catastrofes", this.domSanitizer.bypassSecurityTrustResourceUrl('./assets/permisos/landslide.svg'))
      .addSvgIcon("antenas", this.domSanitizer.bypassSecurityTrustResourceUrl('./assets/permisos/antenna.svg'))
      .addSvgIcon("regularizacion", this.domSanitizer.bypassSecurityTrustResourceUrl('./assets/permisos/worker.svg'))
      .addSvgIcon("institucion", this.domSanitizer.bypassSecurityTrustResourceUrl('./assets/permisos/fire-station.svg'))


    this.form = this.store.select('form')
    this.storeN.select('contador').subscribe(
      response => {
        this.contador_definitivo = response.contador
      },
      error => {
        console.error(error)
      }
    )
    localStorage.clear();

    this.getFormularios();
  }

  ngDoCheck() {
    this.expandedItem = sessionStorage.getItem("expandedItem")
  }

  ngOnInit() {
    if (!sessionStorage.getItem('identity-domCloud') || !sessionStorage.getItem('token-domCloud')) {
      this._router.navigate(['/']);
    } else {
      this.identity = this._userService.getIdentity();
      this.token = this._userService.getToken();
    }
    this._sidenavService.setSidenav(this.sidenav);

    this.getComunas()
  }


  verBorradores() {
    const formOptions = this.dialog.open(BorradoresComponent, {
      width: '690px',      
      maxWidth: '75vw'       
    });
  }
  mouseenter() {
    if (!this.isExpanded) {
      this.isShowing = true;
    }
  }

  mouseleave() {
    if (!this.isExpanded) {
      this.isShowing = false;
    }
  }

  getFormularios() {
    this._userService.getFormularios().subscribe(
      (response) => {

        this.materias = response.materias;
      },
      error => {
        console.log("error", error)
      });
  }


  getForm(id?, title?, online?) {
    localStorage.clear();

    if (online) {
      this.store.dispatch(new FormActions.FormUpdate(id, title))
      this.storeF.dispatch(new FinalFormactions.FinalFormCreate({
        newFormValues: {
          formulario: '1.1',
          tipo_solicitud: 'prueba',
        }
      }))

      setTimeout(() => {
        this.storeF.dispatch(new FinalFormactions.FinalFormCreate({
          newFormValues: {
            proyectos: []
          }
        }))
      }, 2000)
      if (this.generico == true) {

        localStorage.setItem("form", '0.1')
        localStorage.setItem("formId", id)
        localStorage.setItem("formIdOK", "cambiado")
        localStorage.setItem("formTitle", title)
      } else {
        localStorage.setItem("form", id)
        localStorage.setItem("formTitle", title)
      }
      setTimeout(() => {
        this.sidenav.toggle(false);
      }, 200)
    }
    else {
      alert("El formulario seleccionado solo se puede realizar presencialmente")
    }

  }
  back() {
    this.store.dispatch(new FormActions.FormUpdate('0', ''))
    localStorage.clear();
    this._router.navigate(['/inicio'])
  }
  logout() {
    this.store.dispatch(new FormActions.FormUpdate('0', ''))
    sessionStorage.removeItem("identity-domCloud");
    sessionStorage.removeItem("token-domCloud");
    this._router.navigate(['/inicio']);
  }

  getSolicitudes() {
    this.dialog.open(SolicitudesExpComponent);
  }

  getSolic() {
    this.notification_count = 0;
    var contador = 0;
    this._userService.getSolicitudes().subscribe(
      response => {
        for (let index = 0; index < response.length; index++) {
          const element = response[index];
          if (element.fieldData.Estado == 3 && (element.fieldData.Notificado == "" || element.fieldData.Notificado == null)) {
            this.notification_count++;
          }
          if (contador == (response.length - 1)) {
            this.storeN.dispatch(new NotificationActions.NotificationUpdate(this.notification_count))
            if (contador > 0) {
              this.toastr.warning('Pre-ingresos Rechazados', `Tienes ${this.notification_count} solicitude(s) de expediente rechazadas`);
            }
          }
          contador++;
        }
      },
      error => {
        console.log("main-nav.component.ts error", error)
      })
  }

  getComunas() {
    this.spinner.show();
    this._userService.getComunas().subscribe(res => {
      for (let i = 0; i < res.length; i++) {
        this.comunas.push(res[i].fieldData.COM_Nombre)
      }
      localStorage.setItem("comunas", JSON.stringify(this.comunas));
    }, error => {
      this.spinner.hide();
      alert("No se pudo cargar la información para el trámite, intente más tarde.")
      console.log(error)
    })
  }
}